import React from "react";
import PropTypes from "prop-types";

import Portal from "../Portal/Portal";

import "./ModalWindow.sass";

function ModalWindow({ title, titleClass, isOpen, onCancel, children }) {
  return (
    <>
      {isOpen && (
        <Portal>
          <div className="modalOverlay">
            <div className="modalWindow">
              <span
                onClick={onCancel}
                className="modalClose"
                aria-hidden="true"
              />
              <div className="modalContainer">
                <div className="modalHeader">
                  <div className={`modalTitle ${titleClass}`}>{title}</div>
                </div>
                <div className="modalBody">{children}</div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
}

ModalWindow.propTypes = {
  title: PropTypes.string,
  titleClass: PropTypes.string,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  children: PropTypes.node,
};

ModalWindow.defaultProps = {
  title: "Modal Window",
  titleClass: "",
  isOpen: false,
  onCancel: () => {},
  children: null,
};

export default ModalWindow;
